import { FC } from 'react';

import { ImagesApp } from '../../../../constants/images';
import { SafeLanguages } from '../../../../enums/safeLanguages';
import { useI18nContext } from '../../../../hooks/contexts/i18n.context';
import * as Style from './styles.localeSelect';

const countries = Object.keys(ImagesApp.countries)
  .map(e => ({ [e] : e.split('_')[0].toUpperCase() }));

const OptionsSelect: FC = () => {
  const { updateLocale } = useI18nContext();

  return (
    <Style.StyledContainerLocaleSelect id="container-locale-select">
      {
        countries.map((country, index) => {
          const [ keyCountry, countryAcronym ] = Object.entries(country)[0] as [keyof typeof SafeLanguages, string];

          return (
            <Style.StyledButtonLocaleSelect
              id={`button-locale-select_${index}`}
              key={index}
              onClick={() => updateLocale(SafeLanguages[keyCountry])}>
              <Style.StyledBadgeLocale
                id={`badge-locale_${index}`}
                src={ImagesApp.countries[keyCountry]} />
              <Style.StyledTextMenu
                id={`text-menu-locale_${index}`}
                data-testid={`text-menu-locale_${index}`}
              >
                {countryAcronym}
              </Style.StyledTextMenu>
            </Style.StyledButtonLocaleSelect>
          );
        })
      }
    </Style.StyledContainerLocaleSelect>
  );
};

export default OptionsSelect;
